import { ToastContainer, Slide, TypeOptions } from "react-toastify";
import Icon from "./icon";
import styles from "./toaster.module.css";

const contextClass: Record<TypeOptions, string> = {
  success: styles.success,
  error: styles.error,
  info: styles.info,
  default: styles.default,
  warning: styles.warning,
};

export default function Toaster() {
  return (
    <ToastContainer
      toastClassName={(context) =>
        `${contextClass[context?.type || "default"]} ${styles.toast}`
      }
      position="bottom-center"
      autoClose={8000}
      icon={({ type }) => {
        switch (type) {
          case "info": {
            return (
              <span className={styles.infoIcon}>
                <Icon name="Zap" size={18} />
              </span>
            );
          }
          case "error": {
            return (
              <span className={styles.errorIcon}>
                <Icon name="XCircle" size={18} />
              </span>
            );
          }
          case "success": {
            return (
              <span className={styles.checkCircle}>
                <Icon name="CheckCircle" size={18} />
              </span>
            );
          }
          case "warning": {
            return (
              <span className={styles.warningIcon}>
                <Icon name="AlertCircle" size={18} />
              </span>
            );
          }
          default: {
            return (
              <span className={styles.infoIcon}>
                <Icon name="Zap" size={18} />
              </span>
            );
          }
        }
      }}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      transition={Slide}
    />
  );
}
